import { ToastrService } from 'ngx-toastr';

import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { SpinnerService } from '../../../services/spinner.service';
import { ApiBaseAttribute, ApiSetExhibitAttributesRequest } from '../../../api-client-module';
import { ProjectLanguage } from '../../../firestore-models/project-language';

import { ConfigurationService } from '../../../configuration.service';
import { ApiClientService } from '../../../api-client.service';
import { AppConst } from '../../../app-const';
import { MultiNameDialogComponent } from '../../../common/multi-name-dialog/multi-name-dialog.component';
import { TranslateService } from '@ngx-translate/core';

export interface ExhibitAttributeDialogData {
  change_type: number;
  exhibitAttribute?: ApiBaseAttribute;
}

@Component({
  selector: 'app-exhibit-attribute-dialog',
  templateUrl: './exhibit-attribute-dialog.component.html',
  styleUrls: ['./exhibit-attribute-dialog.component.css'],
  standalone: false,
})
export class ExhibitAttributeDialogComponent implements OnInit {

  projectId: string;
  //展示属性情報
  exhibitAttribute?: ApiBaseAttribute;
  isAdded: boolean = false;
  projectLanguages!: Array<ProjectLanguage>;

  //展示属性情報フォーム
  exhibitAttributeFormGroup!: FormGroup;
  exhibitAttributeIdControl!: FormControl;
  exhibitAttributeNameControl!: FormControl;

  // ユーザータイプ
  readonly USER_TYPE_USER: number = AppConst.MANAGE_USER_TYPE_USER;
  userType!: number;
  isEdit: boolean = false;

  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<ExhibitAttributeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ExhibitAttributeDialogData,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private apiClientService: ApiClientService,
    private spinnerService: SpinnerService,
    private toastr: ToastrService,
  ) {
    this.projectId = this.configurationService.getProjectId();
    this.userType = this.configurationService.getUserType();
    this.isEdit = this.configurationService.getIsEdit();
  }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.exhibitAttribute = this.data.exhibitAttribute;
    if (!this.exhibitAttribute) {
      this.exhibitAttribute = {
        attribute_id: '',
        attribute_names: [],
        project_id: this.projectId,
        enabled: true
      };
      this.isAdded = true;
    }
    this.createForm();
    this.exhibitAttributeIdControl = this.exhibitAttributeFormGroup.get('exhibitAttributeId') as FormControl;
    this.exhibitAttributeNameControl = this.exhibitAttributeFormGroup.get('exhibitAttributeName') as FormControl;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang;
  }

  //以下、フォームの記入エラー表示
  public getErrorMessageToExhibitAttributeId() {
    return this.exhibitAttributeIdControl.hasError('required')
      ? this.translate.instant('必須項目')
      : this.exhibitAttributeIdControl.hasError('pattern')
          ? this.translate.instant('半角数字')
          : '';
  }

  public getErrorMessageToExhibitAttributeName() {
    return this.exhibitAttributeNameControl.hasError('required')
      ? this.translate.instant('必須項目')
      : '';
  }

  //フォームの値を各要素に代入
  private createForm() {
    this.exhibitAttributeFormGroup = this.formBuilder.group(
      {
        exhibitAttributeId: [this.exhibitAttribute!.attribute_id, [Validators.required, Validators.pattern('^[0-9]+$')]],
        exhibitAttributeName: [this.exhibitAttribute!.attribute_names, [Validators.required]]
      }
    );
  }

  //更新ボタン
  addExhibitAttribute(): void {
    if (this.exhibitAttributeFormGroup.valid) {
      this.exhibitAttribute!.attribute_id = this.exhibitAttributeIdControl.value;
      this.exhibitAttribute!.attribute_names = this.exhibitAttributeNameControl.value;
      if (this.exhibitAttribute) {
        let request: ApiSetExhibitAttributesRequest = {
          access_token: '',
          change_type: this.data.change_type,
          attributes: [this.exhibitAttribute]
        }
        this.spinnerService.openSpinner();
        this.apiClientService.setExhibitAttributes(request).then(
          response => {
            if (response!.ret === AppConst.API_RET_SUCCESS) {
              this.toastr.success(this.translate.instant('登録しました。'));
              this.dialogRef.close();
            } else if (response!.ret === AppConst.API_RET_ALREADY_EXIST_DATA) {
              this.toastr.error(this.translate.instant('既に同じIDが登録済みです。'), '', { timeOut : 5000 });
            } else {
              console.error('api update error. ret='+response!.ret);
              this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
            }
          }
        ).catch(
          error => {
            console.log(error);
            this.toastr.error(this.translate.instant('登録できませんでした。'), '', { timeOut : 5000 });
          }
        ).finally(
          () => {
            this.spinnerService.closeSpinner();
          }
        );
      }
    }
  }

  //属性名称ダイアログ
  openAttributeNameDialog(): void {
    const dialogRef = this.dialog.open(MultiNameDialogComponent, {
      width: '60%',
      height: '90%',
      disableClose: true,
      data: { names: this.exhibitAttribute!.attribute_names }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.exhibitAttribute!.attribute_names = result;
        this.exhibitAttributeNameControl.setValue(this.exhibitAttribute!.attribute_names);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
